import {useState, useEffect } from 'react';

// Manages pagination (cursor based or keyset based)
export const useRecordPagination = ({ search, worker, dateFrom, dateTo }) => {
    const [cursor, setCursor] = useState(0);
    const [cursorHistory, setCursorHistory] = useState([0]);

    useEffect(() => {
        setCursor(0);
        setCursorHistory([0]);
    }, [search, worker, dateFrom, dateTo]);

    const handleNext = (nextCursor) => {
        setCursorHistory(h => [...h, nextCursor]);
        setCursor(nextCursor);
    };
    const handlePrev = () => {
        const newHistory = cursorHistory.slice(0, -1);
        setCursorHistory(newHistory);
        setCursor(newHistory[newHistory.length -1]);
    };

    const isFirstPage = cursor === 0;

    return { cursor, isFirstPage, handleNext, handlePrev };
}